import Vue from 'vue'
import { formatDistance, parseJSON, parseISO } from 'date-fns'
import { format, utcToZonedTime } from 'date-fns-tz'

Vue.filter('localDate', function (value, formatString = 'MM/dd/yyyy') {
	if (!value) return ''
	const newDate = new Date(value)
	return newDate.toLocaleString('en-US', {
		timeZone: 'UTC',
		month: 'numeric', // "1"
		day: 'numeric', // "1"
		year: 'numeric' // "2019"
	})
})

Vue.filter('humanDate', function (value) {
	if (!value) return ''
	const newDate = new Date(value)
	return newDate.toLocaleString('en-US', {
		month: 'long', // "Jun"
		day: 'numeric', // "01"
		year: 'numeric' // "2019"
	})
})

Vue.filter('localDateTime', function (value, formatString = 'MM/dd/yyyy @ hh:mm a') {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	return format(jsonDate, formatString)
})

Vue.filter('dayFullDate', function (value, formatString = 'weekday, m d,Y') {
	if (!value) return ''
	const newDate = new Date(value)
	return newDate.toLocaleString('en-US', {
		timeZone: 'UTC',
		weekday: 'long',
		month: 'short',
		day: 'numeric',
		year: 'numeric'
	})
})

Vue.filter('humanDateTime', function (value, formatString = 'LLL d, y @ hh:mm a') {
	if (!value) return ''
	const parsedTime = parseISO(value)
	return format(utcToZonedTime(parsedTime, 'UTC'),
		formatString,
		{ timeZone: 'UTC' })
})

Vue.filter('timeSince', function (value, showAgo = true) {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	return formatDistance(jsonDate, new Date()) + ( showAgo ? ' ago' : '')
})

Vue.filter('money', function (num) {
	if (!num) {
		num = 0
	}

	try {
		num = Number(num)

		return num.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		})
	} catch (e) {
		return 'err'
	}
})

Vue.filter('numeric', function (value) {
	return Number(value).toLocaleString()
})

Vue.filter('prettyBytes', function (num) {
	// jacked from: https://github.com/sindresorhus/pretty-bytes
	num = parseInt(num, 10)

	if (typeof num !== 'number' || isNaN(num)) {
		throw new TypeError('prettyBytes expected a number, could not convert')
	}

	let exponent
	let unit
	let neg = num < 0
	let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	if (neg) num = -num
	if (num < 1) return (neg ? '-' : '') + num + ' B'

	exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
	num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
	unit = units[exponent]

	return (neg ? '-' : '') + num + ' ' + unit
})

Vue.filter('capitalize', function (data) {
	let capitalize = []
	data.split(' ').forEach(word => {
		capitalize.push(
			word.charAt(0).toUpperCase() +
			word.slice(1).toLowerCase()
		)
	})
	return capitalize.join(' ')
})
